import { withNamespaces } from 'react-i18next'
import React, { createRef, useEffect, useRef, useState } from 'react'
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from 'reactstrap';

import { 
    Offcanvas
} from "react-bootstrap";

import { FilterTabContent } from './components/FilterTabContent'
import IndependentTab from './components/IndependentTab'

const TableFilter = ({ t, tabs, defaultActiveTab, onOkButtonClicked, className }) => {
    const [activeTab, setActiveTab] = useState(
        tabs.find((tab) => tab.name === defaultActiveTab) || tabs[0]
    )
    const [showElseTabs, setShowElseTabs] = useState(false)
    const [filters, setFilters] = useState({})
    const [ hiddenTabsStartIndex, setHiddenTabsStartIndex ] = useState(-1)
    const [ dropdownFiltersCount, setDropdownFiltersCount ] = useState(0)
    const [ independentFiltersCount, setIndependentFiltersCount ] = useState(0)
    const [ currentConvasToShow, setCurrentConvasToShow ] = useState(null)

    const navRefs = useRef([]);

    const [dropdownOpen, setDropdownOpen] = useState(false)

    const toggle = () => setDropdownOpen((prevState) => !prevState)

    const tabFilterChanged = ({ filterName, value }) => {
        setFilters((currentState) => {
            const newState = { ...currentState }
            newState[filterName] = value;
            return newState
        })

        const tab = activeTab.name !== filterName ? tabs.find((tab) => tab.name === filterName) : activeTab

        tab.onFilterChange && tab.onFilterChange(value, {
            isConvas: !!currentConvasToShow
        })
    }

    const resetConvasTabFilter = ({ filterName }) => {
        setFilters((currentState) => {
            const newState = { ...currentState }
            newState[filterName] = null;
            
            setTimeout(() => {
                onOkButtonClicked(newState)
            }, 250);

            return newState
        })
    }

    const calculateFiltersCounts = () => {
        setDropdownFiltersCount(
            Object.entries(filters).reduce((count, [key, value]) => {
                const tab = tabs.find((tab) => tab.name === key)
                
                if(!tab?.displayIndependently){
                    if (Array.isArray(value)) {
                        return count + (value.length > 0 ? 1 : 0);
                    }
                    return count + ((typeof value !== 'undefined' && value !== null && value !== '' && value !== 'all') ? 1 : 0);
                }
                return count;
            }, 
            0)
        )

        setIndependentFiltersCount(
            Object.entries(filters).reduce((count, [key, value]) => {
                const tab = tabs.find((tab) => tab.name === key)

                if(tab?.displayIndependently){
                    if (Array.isArray(value)) {
                        return count + (value.length > 0 ? 1 : 0);
                    }
                    return count + ((typeof value !== 'undefined' && value !== null && value !== '' && value !== 'all') ? 1 : 0);
                }
                return count;
            }, 
            0)
        )
    }

    const resetFilters = () => {
        setFilters({})
        setDropdownFiltersCount(0)
        setIndependentFiltersCount(0)

        onOkButtonClicked && onOkButtonClicked()
        setDropdownOpen(false)
    }

    const resetDropdownFilters = () => {
        setFilters((currentState) => {
            const newState = {}
            for(const key in currentState){
                const tab = tabs.find((tab) => tab.name === key)
                if(tab && tab.displayIndependently){
                    newState[key] = currentState[key]
                }
            }

            onOkButtonClicked && onOkButtonClicked(null, newState)

            return newState
        })
        setDropdownFiltersCount(0)
        setDropdownOpen(false)
    }

    useEffect(() => {
        setActiveTab(
            tabs.find(
                (tab) => tab.name === (activeTab?.name || defaultActiveTab)
            ) || tabs[0]
        )
    }, [tabs])

    useEffect(() => {
        if(dropdownOpen){
            let width = 0
            let foundIndex = -1
            for(let i = 0; i < navRefs.current.length; i++){
                width += navRefs.current[i]?.current?.offsetWidth || 0;

                if(width >= 410){
                    foundIndex = i
                    break;
                }
            }

            setHiddenTabsStartIndex(foundIndex)
        }
        else{
            setHiddenTabsStartIndex(-1)
        }
    }, [dropdownOpen])

    useEffect(() => {
        calculateFiltersCounts()
    }, [ filters ])

    useEffect(() => {
        if(!showElseTabs){
            setActiveTab(tabs[0])
        }
    }, [showElseTabs])

    if(navRefs.current.length !== tabs.length){
        navRefs.current = Array(tabs.length)
        .fill()
        .map((_, i) => navRefs.current[i] || createRef());        
    }

    const tabsToDisplay = tabs.filter((tab) => {
        return tab.type !== 'search_textbox' || !tab.displayIndependently
    })

    const independentTabs = tabs.filter((tab) => tab.displayIndependently)

    const unIndependentTabsCount = tabs.filter((tab) => !tab.displayIndependently).length

    const totalAppliedFiltersCount = independentFiltersCount + dropdownFiltersCount;

    return (
        <div className={`custom-table-filter${className ? ` ${className}` : ''}`}>
            <div className='desktop d-none d-lg-flex'>
                {totalAppliedFiltersCount > 0 && (
                    <Button
                        onClick={resetFilters}
                        color='secondry'
                        size='sm'
                        className="border-0 shadow-none me-3 reset-btn"
                    >
                        {t('Reset')}
                    </Button>
                )}

                {independentTabs.length > 0 && (
                    <div
                        className='me-2 d-flex gap-2 justify-content-center align-items-center independent-tabs'
                    >
                        {independentTabs.map((tab, index) => {
                            return (
                                <IndependentTab 
                                    key={index}
                                    {...tab}
                                    defaultValue={tab.defaultValue}
                                    onFilterChange={tabFilterChanged}
                                />
                            )
                        })}
                    </div>
                )}

                {unIndependentTabsCount > 0 && (   
                    <Dropdown 
                        isOpen={dropdownOpen} 
                        toggle={toggle}
                        direction="up"
                    >
                        <DropdownToggle 
                            caret 
                            color='secondary' 
                            outline
                            style={{
                                width: "148px"
                            }}
                        >
                            <i className='ri-filter-3-fill' />
                            <span>{t('Filter')}</span>
                            {
                                dropdownFiltersCount > 0 && (
                                    <span className="filter-badge">
                                        {dropdownFiltersCount}
                                    </span>
                                )
                            }
                        </DropdownToggle>

                        <DropdownMenu 
                            className='dropdown-menu-end'
                        >
                            <div className='filters-container'>
                                <div className='navs-container d-flex justify-content-center'>
                                    <Nav tabs>
                                        {tabsToDisplay.map((tab, index) => {
                                            return (
                                                <NavItem
                                                    hidden={hiddenTabsStartIndex >= 0 && index > hiddenTabsStartIndex && !showElseTabs}
                                                    key={index}
                                                    onClick={() => setActiveTab(tab)}
                                                    className={`${
                                                        activeTab?.name === tab.name &&
                                                        'active'
                                                    }`}
                                                >
                                                    <NavLink innerRef={navRefs.current[index]}>
                                                        {tab.icon && (
                                                            tab.icon
                                                        )}
                                                        <span>{t(tab.title)}</span>
                                                    </NavLink>
                                                </NavItem>
                                            )
                                        })}
                                        {hiddenTabsStartIndex > -1 && (
                                            <NavItem
                                                key='nav-else-btn'
                                            >
                                                <NavLink onClick={() => setShowElseTabs(!showElseTabs)}>
                                                    {showElseTabs ? (
                                                        <>
                                                            <i className='ri-close-line' />
                                                            <span>{t('Show Less')}</span>
                                                        </>
                                                    ): (
                                                        <>
                                                            <i className='ri-more-line' />
                                                            <span>{t('Show More')}</span>
                                                        </>
                                                    )}
                                                    
                                                </NavLink>
                                            </NavItem>
                                        )}
                                    </Nav>
                                </div>

                                <div className='navs-content-container'>
                                    <TabContent activeTab={activeTab.name}>
                                        {tabsToDisplay.map((tab, index) => {
                                            return (
                                                <TabPane key={index} tabId={tab.name}>
                                                    <FilterTabContent
                                                        {...tab}
                                                        idPrefix='dropdown'
                                                        defaultValue={tab.defaultValue}
                                                        onFilterChange={tabFilterChanged}
                                                    />
                                                </TabPane>
                                            )
                                        })}
                                    </TabContent>
                                </div>

                                <div className='actions-container gap-3 d-flex align-items-center justify-content-end'>
                                    <Button
                                        color='primary'
                                        size='sm'
                                        onClick={() => {
                                            onOkButtonClicked && onOkButtonClicked(filters)
                                            setDropdownOpen(false)
                                        }}
                                    >
                                        {t('OK')}
                                    </Button>

                                    <Button
                                        onClick={resetDropdownFilters}
                                        color='secondry'
                                        size='sm'
                                    >
                                        {t('Reset')}
                                    </Button>
                                </div>
                            </div>
                        </DropdownMenu>
                    </Dropdown>
                )}
            </div>

            <div className='mobile d-lg-none'>
                <div className='convas-filters-header'>
                    <span>
                        {`${t('Filters')} ${totalAppliedFiltersCount > 0 ? '(' + totalAppliedFiltersCount + ')' : ''}`}
                    </span>
                </div>
                <div className='convas-filters'>
                    {tabs.map((tab, index) => {
                        const hasTabFilter = filters[tab.name] && filters[tab.name] !== 'all'

                        return (
                            <div
                                key={index}
                                className='convas-filter-item'
                            >
                                <Button
                                    color={hasTabFilter ? 'danger' : 'secondary'}
                                    outline
                                    onClick={() => setCurrentConvasToShow(tab.name)}
                                >
                                    {hasTabFilter && (
                                        <i 
                                            className='ri-close-line align-middle me-1' 
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                resetConvasTabFilter({
                                                    filterName: tab.name
                                                });
                                            }}
                                        />
                                    )}
                                    {t(tab.title)}
                                </Button>

                                <Offcanvas
                                    show={currentConvasToShow === tab.name}
                                    onHide={() => setCurrentConvasToShow(null)}
                                    placement="bottom"
                                    style={{ height: "70vh" }}
                                >
                                    <Offcanvas.Header closeButton>
                                        <Offcanvas.Title>
                                            {t(tab.title)}
                                        </Offcanvas.Title>
                                    </Offcanvas.Header>

                                    <Offcanvas.Body>
                                        <FilterTabContent
                                            {...tab}
                                            idPrefix='convas'
                                            defaultValue={tab.defaultValue}
                                            onFilterChange={tabFilterChanged}
                                        />

                                        <div className='d-flex justify-content-end align-items-center border-top pt-2 convas-actions-container'>
                                            <Button 
                                                type='button'
                                                color='primary'
                                                onClick={() => {
                                                    onOkButtonClicked && onOkButtonClicked(filters);
                                                    setCurrentConvasToShow(null);
                                                }}
                                            >
                                                {t('Ok')}
                                            </Button>
                                        </div>
                                    </Offcanvas.Body>
                                </Offcanvas>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default withNamespaces()(TableFilter)
